import {ColumnSort} from '@tanstack/table-core';
import getParamFromSortingState from '@/utils/getParamFromSortingState';
import QueryContext from '@/api/QueryContext';
import api from '@/api';

const DEFAULT_PER_PAGE = 25;

const vettingHubFetchers = {
  vettableCreators: (context: QueryContext) => {
    return api.get('/vettable_creators', {
      params: {handle: context.meta?.handle, case_insensitive: true},
    });
  },
  creatorBrandSafetyVettings: (context: QueryContext) => {
    return api.get('/creator_brand_safety_vettings', {
      params: {
        brand_id: context.meta?.brandId,
        page: context.pageParam,
        per_page: context.meta?.perPage || DEFAULT_PER_PAGE,
        ...(context.meta?.tab ? {tab: context.meta.tab} : {}),
        ...(context.meta?.profileId
          ? {profile_id: context.meta.profileId}
          : {}),
        ...(context.meta?.sorting
          ? getParamFromSortingState(context.meta.sorting as ColumnSort[])
          : {}),
        ...(context.meta?.search ? {search: context.meta.search} : {}),
        ...(context.meta?.scope ? {scope: context.meta.scope} : {}),
      },
    });
  },
};

export default vettingHubFetchers;
